import { doc, setDoc } from 'firebase/firestore';
import { firestore } from '../helpers/firebase';

export const setDraftDetails = async (data, year = new Date().getFullYear().toString()) => {
  const setDraftDisableData = await setDoc(doc(firestore, 'draft', year), data, { merge: true })
    .then(() => ({ success: true, message: 'Successfully Updated!' }))
    .catch(error => ({ success: false, message: `Error Saving: ${error}` }));
  return setDraftDisableData;
};
